/**
 *  Filename ....: pastassistance.component.ts
 *  Created by ..: ianday
 *  on Date .....: 11/29/23
 **/
import { Component, HostListener, Input, OnInit } from '@angular/core';
import { ServiceRequestsService } from "../../../../services/service-requests.service";
import { MatTableDataSource } from "@angular/material/table";
import { ServiceRequest } from "../../../../models/service.request";
import { Settings } from "../../../../services/settings";
import { PastRequests } from "../../../../models/pastrequests";

@Component({
	selector: 'app-pastassistance',
	templateUrl: './pastassistance.component.html',
	styleUrls: ['./pastassistance.component.css']
})

export class PastAssistanceComponent implements OnInit {

	public dataSource: MatTableDataSource<PastRequests>;
	public records: any;
	public allRecords: any;
	public showDeniedServices: boolean = false;
	public selectedRecord: PastRequests;
	public Idx: number = -1;
	public busyCursor: boolean = false;
	public restrictedAgencyFlag =false;

	showPastAssistance = false;
	showDenialRequests = false;
	showPreviousNeed = false;
	showAllAgency = false;
	showRestrictedAgency = false;



	public displayedColumns: string[] = ['dateCompleted', 'requestType', 'totalAmountProvided']

	fromSource: string;
	@Input() set from(value: string) {
		this.fromSource = value;
	}
	constructor(public serviceRequestsService: ServiceRequestsService) {

	}

	ngOnInit() {

	}
	public onShowHandler(caseId: number): void {

		if ((caseId === null) || (caseId === 0)) {
			return;
		}
		this.Idx = -1;
		this.busyCursor = true;
		this.selectedRecord = new PastRequests();
		this.setSecurityPrivileges();
		if(this.showAllAgency===false &&this.showRestrictedAgency===false){
			return;
		}

		this.serviceRequestsService.getAllPastServiceRequestsByCaseId(caseId,this.restrictedAgencyFlag).subscribe(
			(result) => {
				if (result.length === 0) {
					this.busyCursor = false;
					return;
				}
				this.allRecords = result;

				this.setData(this.showDeniedServices);
				this.busyCursor = false;
			},
			(error) => {
				Settings.getInstance().handleError(error, 'fetching past requests');
				this.busyCursor = false;
			});
	}
	setSecurityPrivileges() {
		if (this.fromSource === 'cases') {
			this.showPastAssistance = Settings.getInstance().hasPrivilege('CLIENTS_CASE_DETAILS_PAST_ASSISTANCE', "SHOW");
			this.showDenialRequests = Settings.getInstance().hasPrivilege('CLIENTS_CASE_DETAILS_PAST_ASSISTANCE_DENIED', "SHOW");
			this.showPreviousNeed = Settings.getInstance().hasPrivilege('CLIENTS_CASE_DETAILS_PAST_ASSISTANCE_PREV_NEEDS', "SHOW");
			this.showAllAgency = Settings.getInstance().hasPrivilege('CLIENTS_CASE_DETAILS_PAST_ASSISTANCE_ALL', "SHOW");
			this.showRestrictedAgency = Settings.getInstance().hasPrivilege('CLIENTS_CASE_DETAILS_PAST_ASSISTANCE_AGENCY_RESTRICTED', "SHOW");
			
		} else {
			this.showPastAssistance = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_PAST_ASSISTANCE', "SHOW");
			this.showDenialRequests = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_PAST_ASSISTANCE_DENIED', "SHOW");
			this.showPreviousNeed = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_PAST_ASSISTANCE_PREV_NEEDS', "SHOW");
			this.showAllAgency = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_PAST_ASSISTANCE_ALL', "SHOW");
			this.showRestrictedAgency = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_PAST_ASSISTANCE_AGENCY_RESTRICTED', "SHOW");
		}
		if(this.showAllAgency === false && this.showRestrictedAgency === true){
			this.restrictedAgencyFlag = true;
		}

	}
	public setData(deniedFlag: boolean): void {

		if (!deniedFlag) {
			this.records = this.allRecords.filter(s => s.statusId !== 9).filter(s => s.statusId !== 4);
		}
		else {
			this.records = this.allRecords;
		}
		this.dataSource = new MatTableDataSource(this.records);
	}
	public doDeniedFlagChange(): void {
		this.setData(this.showDeniedServices);
	}
	public tableKeyDown(event: any): void {

		const len: number = this.dataSource.filteredData.length;
		if (event.key === 'ArrowDown') {
			if (this.Idx < (len - 1)) {
				this.selectedRecord = this.dataSource.filteredData[++this.Idx];
				this.displayDetail(this.selectedRecord);
			}
		} else if (event.key === 'ArrowUp') {
			if (this.Idx > 0) {
				this.selectedRecord = this.dataSource.filteredData[--this.Idx];
				this.displayDetail(this.selectedRecord);
			}
		}
	}
	@HostListener('matSortChange', ['$event'])
	public onSortChange(event: any) {

		if (this.dataSource === undefined) {
			return;
		}

		if (event.direction === 'asc') {
			this.records.sort((a, b) =>
				a[event.active].localeCompare(b[event.active]));
		} else {
			this.records.sort((a, b) =>
				b[event.active].localeCompare(a[event.active]));
		}

		this.dataSource.data = this.records;
		this.selectRow();

	}
	public selectRow() {
		if (this.selectedRecord.id === 0) {
			this.unSelectRow();
			return;
		}
		this.Idx = this.dataSource.filteredData.findIndex(s => s.id === this.selectedRecord.id);
	}
	public unSelectRow() {

		if (this.dataSource === undefined) {
			return;
		}

		this.Idx = -1;
		this.selectedRecord = new PastRequests();
	}
	public onRowClicked(selected: any): void {

		this.selectedRecord = selected;
		this.selectRow();
		this.displayDetail(this.selectedRecord);
	}
	public displayDetail(selected: any): void {

	}
	public returnStatusColor(requestStatusId: number): string {

		if (requestStatusId === null) {
			return '';
		}
		switch (requestStatusId) {
			case 1:
				return 'black'; // Unmatched
			case 2:
				return 'blue'; // Matched
			case 3:
				return 'green'; // Approved
			case 4:
				return 'red'; // Denied
			case 5:
				return 'orange'; // Cancelled
			default:
				return ''; // Handle any other status or return a default color
		}
	}
}

